export enum MapInfoBoxTypeEnum {
    lpis,
    parcel,
    parcels_list,
    building,
    measure_distance,
    measure_area,
    parcel_to_group,
    parcel_or_lpisv_search,
    // InfoBoxes showed the same time with above Infobox
    lpisUserSelection,
    lpisEndingContract,
    parcelSelectByShapeDrawing,
    parcelSelectByAddArea,
    parcelSplitting,
}